import { useState } from "react";
import { FAQS } from "@/lib/site";
import { useSEO } from "@/lib/seo";
import SectionHeading from "@/components/SectionHeading";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQs() {
  useSEO({
    title: "FAQs — Ayurvedic Care Questions",
    description: "Answers to common questions about PCOS, infertility, pregnancy and Ayurvedic care at Nari Arogya, Pune.",
    path: "/faqs",
  });

  const categories = ["All", ...Array.from(new Set(FAQS.map((f) => f.category)))];
  const [active, setActive] = useState("All");
  const filtered = active === "All" ? FAQS : FAQS.filter((f) => f.category === active);

  return (
    <>
      <section className="pt-32 pb-14 lotus-bg" data-testid="faqs-hero">
        <div className="na-container text-center">
          <SectionHeading
            eyebrow="Questions Answered"
            title="Frequently Asked Questions"
            subtitle="Everything you need to know about our approach, treatments and Ayurveda."
            align="center"
          />
        </div>
      </section>

      <section className="section">
        <div className="na-container max-w-4xl">
          <div className="flex flex-wrap gap-2 mb-10 justify-center" data-testid="faq-categories">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition ${
                  active === c
                    ? "bg-[color:var(--na-teal)] text-white"
                    : "bg-[color:var(--na-section)] text-[color:var(--na-text)] hover:bg-[color:var(--na-teal)]/10"
                }`}
                data-testid={`faq-cat-${c.toLowerCase()}`}
              >
                {c}
              </button>
            ))}
          </div>

          <Accordion type="single" collapsible className="space-y-3">
            {filtered.map((f, i) => (
              <AccordionItem key={`${active}-${i}`} value={`item-${i}`} className="na-card px-6 border-none" data-testid={`faq-q-${i}`}>
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold py-5 hover:no-underline">
                  <span className="flex-1">{f.q}</span>
                </AccordionTrigger>
                <AccordionContent className="text-[color:var(--na-muted)] leading-relaxed pb-5 text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </>
  );
}
